module.exports = __webpack_public_path__ + "img/vertical_3_3_5012.9890a8f5.png";